export const BlogsEditorPath = "editor";
export const BlogsReviewerPath = "reviewer";
export const LoginDataStorageKey = "cognito-login-data";